import React, { useState, useEffect } from 'react';
import { Button, Modal, Row, Col, Card, Avatar, Tag, Space, Form, Input, Select, Upload, message, Typography, Table } from 'antd';
import { InfoCircleOutlined, PlusOutlined, ReloadOutlined, PhoneOutlined, HomeOutlined, IdcardOutlined, UploadOutlined, EditOutlined, DeleteOutlined, WarningOutlined, WarningFilled } from "@ant-design/icons";
import { get_ListeChauffeur, createChauffeur, updateChauffeur, deleteChauffeur, addObservation, get_ListeObservationChauffeur, exportChauffeurObservation } from '../../../api/chauffeur';
import * as config from '../../../config/config'
import Notification from '../../../composants/Notification';
import formatDateFr, { getPermissionsFromToken, hasPermission } from "../../../utils/utils";


const { Option } = Select;
const { Text } = Typography;
const Chauffeur = () => {
    const [chauffeurListe, setChauffeurListe] = useState([]);
    const [loadingReload, setLoadingReload] = useState(false);
    const [modalAdd, setModalAdd] = useState(false);
    const [editingChauffeur, setEditingChauffeur] = useState(null);
    const [form] = Form.useForm();
    const [isUpdate, setisUpdate] = useState(false)
    const [isloading, setisloading] = useState(false)
    const [search, setSearch] = useState("");
    const [filteredChauffeur, setfilteredChauffeur] = useState([])
    const [modalAddObservationAdd, setmodalAddObservationAdd] = useState(false);
    const [modalListeObservationAdd, setmodalListeObservationAdd] = useState(false);
    const [currentObservation, setcurrentObservation] = useState({
        "chauffeur_id": null,
        "create_at": null,
        "avertissement": null,
        "description": null
    })
    const [allObservations, setallObservations] = useState([])
    const columnsObservation = [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 80,
            align: "center",
        },
        {
            title: "Date de création",
            dataIndex: "create_at",
            key: "create_at",
            width: 180,
            align: "center",
            render: (date) => new Date(date).toLocaleString(),
        },
        {
            title: "Avertissement",
            dataIndex: "avertissement",
            key: "avertissement",
            align: "center",
            render: (text) => <Text strong>{text}</Text>,
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            align: "center",
            render: (text) => <Text strong>{text}</Text>,
        }

    ];
    const [showToast, setshowToast] = useState(false)
    const [notif, setnotif] = useState({
        "message": null,
        "info": null
    })

    useEffect(() => {
        fetchListeChauffeur();
    }, []);

    const fetchListeChauffeur = async () => {
        const res = await get_ListeChauffeur();
        if (res.status === "success") {
            setChauffeurListe(res.data);
            setfilteredChauffeur(res.data)
        }
    };

    const handleReload = () => {
        setLoadingReload(true);
        setTimeout(() => {
            window.location.reload();
        }, 1500);
    };

    const showModalUpdate = (chauffeur = null) => {
        setisUpdate(true)
        setEditingChauffeur(chauffeur);
        if (chauffeur) {
            form.setFieldsValue({
                ...chauffeur,
                isActive: Number(chauffeur.isActive),
            });
        } else {
            form.resetFields();
        }
        setModalAdd(true);
    };

    const showModalAddObservation = (chauffeur = null) => {
        setcurrentObservation({
            ...currentObservation,
            chauffeur_id: chauffeur.id,
        });
        setmodalAddObservationAdd(true);
    };

    const showModalObservationListe = async (chauffeur = null) => {
        setEditingChauffeur(chauffeur);
        setcurrentObservation({
            ...currentObservation,
            chauffeur_id: chauffeur.id,
        });
        // fetch all observation for this chauffeur
        const res = await get_ListeObservationChauffeur(chauffeur.id);
        setallObservations(res.data);
        setmodalListeObservationAdd(true);
    };

    const showModal = () => {
        form.resetFields()
        setModalAdd(true);
    };

    const handleSaveChauffeur = async (values) => {
        try {
            setisloading(true)
            let avatarBase64 = null;
            if (values.avatar && values.avatar.file) {
                const fileObj = values.avatar.file.originFileObj || values.avatar.file; // fallback si originFileObj n'existe pas

                if (fileObj instanceof File) {
                    avatarBase64 = await new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(fileObj);
                        reader.onload = () => resolve(reader.result);
                        reader.onerror = (error) => reject(error);
                    });
                } else {
                    console.warn("Avatar n'est pas un fichier valide :", fileObj);
                }
            }

            const payload = {
                ...values,
                avatar: avatarBase64, // avatar en Base64 ou null si pas de fichier
            };

            if (isUpdate === true) {
                const res = await updateChauffeur(payload)
                if (res.status === "success") {
                    message.success("Chauffeur ajouté avec succés", 2)
                    setnotif({ ...notif, message: "Chauffeur modifié avec succés", info: "success" })
                    setshowToast(true)
                    setTimeout(() => {
                        window.location.reload()
                    }, 1500);
                } else {
                    message.warning("Erreur lors de la modification du chauffeur !!!")
                    setnotif({ ...notif, message: "Erreur lors de la modification du chauffeur !!!", info: "error" })
                    setshowToast(true)
                    setisloading(false)
                    setTimeout(() => {
                        setshowToast(false)
                    }, 1500);
                }

            } else {
                const res = await createChauffeur(payload)
                if (res.status === "success") {
                    message.success("Chauffeur ajouté vec succés")
                    setnotif({ ...notif, message: "Chauffeur ajouté vec succés", info: "success" })
                    setshowToast(true)
                    setTimeout(() => {
                        window.location.reload()
                    }, 1500);
                } else {
                    message.warning("Erreur lors de l'ajout du chauffeur !!!")
                    setnotif({ ...notif, message: "Erreur lors de l'ajout du chauffeur !!!", info: "error" })
                    setshowToast(true)
                    setTimeout(() => {
                        setshowToast(false)
                    }, 1500);
                    setisloading(false)
                }
            }
        } catch (err) {
            console.error(err);
            message.error("Erreur serveur");
        }
    };

    const handleDelete = async (id) => {
        try {
            const res = await deleteChauffeur(id);
            if (res.status === "success") {
                message.success("Chauffeur supprimé ✅");
                fetchListeChauffeur();
            } else {
                message.error("Erreur lors de la suppression ❌");
            }
        } catch (err) {
            console.error(err);
            message.error("Erreur serveur");
        }
    };

    const handleAddObservation = async () => {
        try {
            if (currentObservation.avertissement === null || (currentObservation.avertissement).length === 0) {
                alert('"Champ obligatoires manquants !!!!')
                setnotif({ ...notif, message: "Champ obligatoires manquants !!!!", info: "warning" })
            } else {
                setisloading(true)
                const res = await addObservation(currentObservation);
                if (res.status === "success") {
                    message.success("Observation ajouté ✅");
                    setnotif({ ...notif, message: "Observation ajouté", info: "success" })
                    setshowToast(true)
                    setTimeout(() => {
                        window.location.reload()
                    }, 1500);
                } else {
                    message.error("Erreur lors de l'enregistrement ❌");
                    setnotif({ ...notif, message: "Erreur lors de l'enregistrement", info: "error" })
                    setshowToast(true)
                    setTimeout(() => {
                        setshowToast(false)
                    }, 1500);
                    setshowToast(false)
                    setisloading(false)

                }
            }

        } catch (err) {
            console.error(err);
            message.error("Erreur serveur");
        }
    };

    const handleExportObservation = async () => {
        try {
            const rs = await exportChauffeurObservation(currentObservation.chauffeur_id);
            setnotif({ ...notif, message: "Démarrage de l'export", info: "success" })
            setshowToast(true)
            setTimeout(() => {
                window.location.reload()
            }, 1500);
        } catch (error) {
            setnotif({ ...notif, message: "Erreur lors de l'export", info: "error" })
            setshowToast(true)
            setTimeout(() => {
                setshowToast(false)
            }, 1500);
        }

    }

    const handleSearchChauffeur = (e) => {
        let text = e.target.value
        setSearch(text)
        console.log(text.length);
        if (text.length === 0) {
            setfilteredChauffeur(chauffeurListe)
        } else {
            let mon_filtre = filteredChauffeur.filter(
                (chauffeur) =>
                    chauffeur.nom.toLowerCase().includes(search.toLowerCase()) ||
                    chauffeur.prenom.toLowerCase().includes(search.toLowerCase())
            );
            setfilteredChauffeur(mon_filtre)
        }
    }

    return (
        <>
            <Row justify="space-between" align="middle">
                <Col>
                    <h3 style={{ marginBottom: "4px" }}><strong>Chauffeurs</strong></h3>
                    <p style={{ margin: 0 }}>
                        {chauffeurListe
                            ? `${chauffeurListe.length} ${chauffeurListe.length > 1 ? "chauffeurs" : "chauffeur"} enregistrés`
                            : "Aucun chauffeur présent"}
                    </p>
                </Col>

                <Col span={10}>
                    <Input.Search
                        placeholder="Rechercher un chauffeur"
                        allowClear
                        onChange={handleSearchChauffeur}
                        style={{ width: "100%" }}
                    />
                </Col>
                <Col>
                    <Space>

                        <Button
                            className='btn btn-success'
                            loading={loadingReload}
                            onClick={handleReload}
                            icon={<ReloadOutlined />}
                        >
                            Actualiser
                        </Button>
                        {
                            hasPermission(getPermissionsFromToken(), "CHAUFFEUR_ADD") && parseInt(localStorage.getItem('fonction_id')) === 1 && <Button type="primary" onClick={() => showModal()} icon={<PlusOutlined />}>
                                Ajouter
                            </Button>
                        }

                    </Space>
                </Col>
            </Row>
            <br />
            <div style={{
                height: '68vh',
                overflowY: "auto"
            }}>
                <Row gutter={[16, 16]}>
                    {filteredChauffeur.map((ch) => (
                        <Col key={ch.id} xs={24} sm={12} md={8} lg={6}>
                            <Card
                                hoverable
                                style={{ textAlign: "center" }}
                                cover={
                                    <Avatar
                                        src={ch.avatar ? config.REACT_APP_ENDPOINT_ + ch.avatar : null}
                                        size={100}
                                        style={{ margin: "16px auto", display: "block" }}
                                    >
                                        {(!ch.avatar) && ch.prenom?.charAt(0)}
                                    </Avatar>
                                }
                                actions={[
                                    ...(hasPermission(getPermissionsFromToken(), "CHAUFFEUR_UPDATE")
                                        ? [
                                            <EditOutlined
                                                key="edit"
                                                onClick={() => showModalUpdate(ch)}
                                                style={{ color: "#1890ff" }}
                                            />,
                                        ]
                                        : []),

                                    ...(hasPermission(getPermissionsFromToken(), "CHAUFFEUR_ADD_OBSERVATION")
                                        ? [
                                            <WarningFilled
                                                key="warning"
                                                onClick={() => showModalAddObservation(ch)}
                                                style={{ color: "#ff3718e3" }}
                                            />,
                                        ]
                                        : []),

                                    ...(hasPermission(getPermissionsFromToken(), "CHAUFFEUR_LIST_OBSERVATION")
                                        ? [
                                            <InfoCircleOutlined
                                                key="info"
                                                onClick={() => showModalObservationListe(ch)}
                                                style={{ color: "green" }}
                                            />,
                                        ]
                                        : []),
                                ]}
                            >
                                <h4 style={{ marginBottom: "8px" }}>
                                    {ch.prenom} {ch.nom}
                                </h4>

                                <div style={{ fontSize: "13px", lineHeight: "1.4" }}>
                                    <div><IdcardOutlined /> CIN: {ch.cin}</div>
                                    <div><HomeOutlined /> {ch.adresse}</div>
                                    <div><PhoneOutlined /> {ch.contact || "N/A"}</div>
                                    <div><IdcardOutlined /> Permis: {ch.permis}</div>
                                </div>

                                <div style={{ marginTop: "8px" }}>
                                    <Tag color={Number(ch.isActive) === 1 ? "green" : "red"}>
                                        {Number(ch.isActive) === 1 ? "Actif" : "Inactif"}
                                    </Tag>
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
            <Modal
                width={600}
                top="5px"
                title={editingChauffeur ? "Modifier un chauffeur" : "Ajouter un chauffeur"}
                open={modalAdd}
                onCancel={() => { setModalAdd(false); setEditingChauffeur(null); setisUpdate(false) }}
                footer={null}
                style={{
                    top: "20%"
                }}
            >

                <Form
                    form={form}
                    layout="horizontal"
                    onFinish={handleSaveChauffeur}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="nom"
                                label="Nom"
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                rules={[{ required: true, message: "Veuillez entrer le nom" }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                name="prenom"
                                label="Prénom"
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                rules={[{ required: true, message: "Veuillez entrer le prénom" }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="adresse"
                                label="Adresse"
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                rules={[{ required: true, message: "Veuillez entrer l’adresse" }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                name="contact"
                                label="Contact"
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="cin"
                                label="CIN &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                rules={[{ required: true, message: "CIN OBLIGATOIRE " }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                name="permis"
                                label="Permis"
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                rules={[{ required: true, message: "Veuillez entrer le type de permis" }]}
                            >
                                <Input placeholder="ex: A-B-C-D" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="isActive"
                                label="Statut "
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                initialValue={1}
                            >
                                <Select
                                    style={{ width: "100%" }}
                                >
                                    <Option value={1}>Actif</Option>
                                    <Option value={0}>Inactif</Option>
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                name="avatar"
                                label="Avatar"
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                valuePropName="file"
                            >
                                <Upload beforeUpload={() => false} maxCount={1}>
                                    <Button icon={<UploadOutlined />}>Choisir une image</Button>
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item
                        name="id"
                        label="id "
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        initialValue={1}
                        style={{
                            display: "none"
                        }}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item wrapperCol={{ span: 24 }}>
                        <Button
                            loading={isloading}
                            type="primary"
                            htmlType="submit"
                            block
                        >
                            {editingChauffeur ? "Mettre à jour" : "Enregistrer"}
                        </Button>
                    </Form.Item>
                </Form>

            </Modal>

            <Modal
                width={700}
                top="5px"
                title={"Observation chauffeur"}
                open={modalAddObservationAdd}
                onCancel={() => { setmodalAddObservationAdd(false); setEditingChauffeur(null); }}
                footer={null}
                style={{
                    top: "10%"
                }}
            >
                <Row>
                    <Col span={8} style={{ textAlign: "center", padding: 8 }}>
                        <span>
                            Avertissement
                        </span>
                    </Col>
                    <Col span={16}>
                        <Input
                            value={currentObservation.avertissement}
                            onChange={(e) => {
                                setcurrentObservation({
                                    ...currentObservation,
                                    avertissement: e.target.value
                                })
                            }}
                        />
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col span={8} style={{ textAlign: "center", padding: 8 }}>
                        <span>
                            Description
                        </span>
                    </Col>
                    <Col span={16}>
                        <Input.TextArea
                            value={currentObservation.description}
                            onChange={(e) => {
                                setcurrentObservation({
                                    ...currentObservation,
                                    description: e.target.value
                                })
                            }}
                        />
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col span={8} style={{ textAlign: "center", padding: 8 }}>

                    </Col>
                    <Col span={16} style={{ textAlign: "center" }}>
                        <Button
                            loading={isloading}
                            className='btn btn-primary'
                            onClick={handleAddObservation}
                            style={{ width: '80%', height: 60 }}
                        >
                            Enregistrer
                        </Button>
                    </Col>
                </Row>
            </Modal>

            <Modal
                width="60%"
                open={modalListeObservationAdd}
                onCancel={() => {
                    setmodalListeObservationAdd(false);
                    setEditingChauffeur(null);
                }}
                footer={null}
                style={{ top: "5%" }}
                title={
                    <>
                        Liste des observations du chauffeur :{" "}
                        <strong>
                            {editingChauffeur
                                ? `${editingChauffeur.prenom} ${editingChauffeur.nom}`
                                : ""}
                        </strong>
                    </>
                }
            >
                {/* ✅ Barre bouton Export sous le titre */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        marginBottom: 16,
                        marginTop: 8,
                    }}
                >
                    <Button
                        onClick={() => {
                            handleExportObservation()
                        }}
                        style={{
                            backgroundColor: "#28a745", // vert plus vif
                            color: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            padding: "8px 20px",
                            cursor: "pointer",
                            fontWeight: "bold",
                            letterSpacing: "0.5px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                            transition: "background 0.3s ease",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#22bb33")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#28a745")}
                    >
                        EXPORT
                    </Button>
                </div>

                <Table
                    bordered
                    columns={columnsObservation}
                    dataSource={allObservations}
                    rowKey="id"
                    pagination={{
                        pageSize: 5,
                        position: ["bottomCenter"],
                        className: "custom-pagination",
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            marginTop: 12,
                        },
                        itemRender: (page, type, originalElement) => {
                            if (type === "page") {
                                return (
                                    <div
                                        style={{
                                            borderRadius: "50%",
                                            minWidth: 32,
                                            height: 32,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            border: "1px solid #d9d9d9",
                                        }}
                                    >
                                        {page}
                                    </div>
                                );
                            }
                            return originalElement;
                        },
                    }}
                />
            </Modal>

            {
                showToast && <Notification message={notif.message} status={notif.info} />
            }

        </>
    );
};

export default Chauffeur;

